/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styles from '../custom.module.css';

const SelectOption = ({ deviceNo, name, image, productCode, revision, onClick }: any): JSX.Element => {
    const hexToBytes = (hex: string): Uint8Array => {
        const bytes = new Uint8Array(hex.length / 2);
        for (let i = 0; i < hex.length; i += 2) {
            bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
        }
        return bytes;
    };

    const bytes = hexToBytes(image);

    // Create blob and object URL
    const blob = new Blob([bytes], { type: 'image/bmp' });
    const url = URL.createObjectURL(blob);
    return (
        <div className={styles.optionElement} onClick={(): void => onClick(deviceNo, revision)}>
            <div>
                <img src={url} />
            </div>

            <div className={styles.optionContent}>
                <div>{name}</div>
                <div>
                    <div>
                        <span>Product:</span> {productCode}
                    </div>
                    <div className={styles.horizontalLine}></div>
                    <div>
                        <span>Revision:</span> {revision}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectOption;
